export default __webpack_public_path__ + "static/media/fake-objects@1x.b4b45f44.png";